export const GET_PATIENTS = 'GET_PATIENTS';
export const GET_CHECK_IN_LIST = 'GET_CHECK_IN_LIST';
export const SELECT_PATIENT = 'SELECT_PATIENT';
export const SELECT_DOCTOR = 'SELECT_DOCTOR';
